/**
 *
 * Asynchronously loads the component for SignInNutritionist
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
